import axios from 'axios'
// import { ElNotification , ElMessageBox, ElMessage, ElLoading } from 'element-plus'
import { message,Modal  } from 'ant-design-vue';
import { getToken } from '@/utils/auth'
import errorCode from '@/utils/errorCode'
import { tansParams, blobValidate } from '@/utils/ruoyi'
import cache from '@/plugins/cache'
import Cookies from "js-cookie";
// import { saveAs } from 'file-saver'
import useUserStore from '@/store/modules/user'
import { createVNode } from "vue";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";

let downloadLoadingInstance;
// 是否显示重新登录
export let isRelogin = { show: false };

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
console.log(process.env.VUE_APP_BASE_API)
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_BASE_API,
  // 超时
  timeout: 1000000
})

// request拦截器
service.interceptors.request.use(config => {
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === false
  // 是否需要防止数据重复提交
  const isRepeatSubmit = (config.headers || {}).repeatSubmit === false
  if (getToken() && !isToken) {
    config.headers['Authorization'] =  getToken() // 让每个请求携带自定义token 请根据实际情况自行修改

     //携带用户信息
     if (Cookies.get('userInfo')) {
      let userInfo=JSON.parse(Cookies.get('userInfo'));
      config.headers['Dept-Id'] =  userInfo.deptId ;
      config.headers['Dept-Name'] =  encodeURIComponent(userInfo.deptName) ;
    }
    if(Cookies.get('ruoyiIds')){
      let ruoyiId=JSON.parse(Cookies.get('ruoyiIds'));
      config.headers['RuoYi-User-Id'] =  ruoyiId.userId;
      config.headers['RuoYi-Dept-Id'] =  ruoyiId.deptId;
    }


  }
  if(config.url.indexOf('zb-cloud-ruoyi')<0){
    config.url=process.env.VUE_APP_BUSINESS_API+config.url
  }
 
  // get请求映射params参数
  if (config.method === 'get' && config.params) {
    let url = config.url + '?' + tansParams(config.params);
    url = url.slice(0, -1);
    config.params = {};
    config.url = url;
   
  }
  if (!isRepeatSubmit && (config.method === 'post' || config.method === 'put')) {
    const requestObj = {
      url: config.url,
      data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
      time: new Date().getTime()
    }
    const requestSize = Object.keys(JSON.stringify(requestObj)).length; // 请求数据大小
    const limitSize = 5 * 1024 * 1024; // 限制存放数据5M
    if (requestSize >= limitSize) {
      console.warn(`[${config.url}]: ` + '请求数据大小超出允许的5M限制，无法进行防重复提交验证。')
      return config;
    }
    const sessionObj = cache.session.getJSON('sessionObj')
    if (sessionObj === undefined || sessionObj === null || sessionObj === '') {
      cache.session.setJSON('sessionObj', requestObj)
    } else {
      const s_url = sessionObj.url;                // 请求地址
      const s_data = sessionObj.data;              // 请求数据
      const s_time = sessionObj.time;              // 请求时间
      const interval = 1000;                       // 间隔时间(ms)，小于此时间视为重复提交
      // if (s_data === requestObj.data && requestObj.time - s_time < interval && s_url === requestObj.url) {
      //   const message = '数据正在处理，请勿重复提交';
      //   console.warn(`[${s_url}]: ` + message)
      //   return Promise.reject(new Error(message))
      // } else {
        cache.session.setJSON('sessionObj', requestObj)
      // }
    }
  }
  return config
}, error => {
    console.log(error)
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    const messageFive = res.data.message ||  res.data.msg 
    console.log(res);
    console.log(code,'1111111111111111111111111111111111111');
    // 获取错误信息
    const msg =  res.data.message || errorCode[code] ||  errorCode['default']
    // 二进制数据则直接返回
    if (res.request.responseType ===  'blob' || res.request.responseType ===  'arraybuffer') {
      return res.data
    }
    if (code === 401) {
      // if (res.request.responseURL.includes('/zb-cloud-ruoyi/getInfo')){
      //   //location.href = '/login';
      //   return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
      // }
        useUserStore().logOut().then(() => {
          location.href = '/login';
          message.error('无效的会话，或者会话已过期，请重新登录。')
        })
        if (!isRelogin.show) {
          isRelogin.show = true;
          console.log('token 过期了');

          Modal.confirm({
            title: '系统提示',
            icon: createVNode(ExclamationCircleOutlined),
            content: '登录状态已过期，您可以继续留在该页面，或者重新登录',
            okText: '重新登录',
            cancelText: '取消',
            onOk() {
              isRelogin.show = false;
              useUserStore().logOut().then(() => {
                location.href = '/login';
              })
            },
            onCancel() {
              isRelogin.show = false;
            },
            class: 'test',
          });

      }
      // message.error('无效的会话，或者会话已过期，请重新登录。')
      // location.href = '/login';
      return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
    } else if (code === 500) {
      message.error(messageFive)
      return Promise.reject(res.data)
    } else if (code === 601) {
      message.warning(msg)
      return Promise.reject(new Error(msg))
    } else if (code !== 200) {
      message.warning(msg)
      return Promise.reject('error')
    } else {
      return  Promise.resolve(res.data)
    }
  },
  error => {
    console.log('err' + error)
    let msg = error.message;
    if (msg == "Network Error") {
      msg = "后端接口连接异常";
    } else if (msg.includes("timeout")) {
      msg = "系统接口请求超时";
    } else if (msg.includes("Request failed with status code")) {
      msg = "系统接口" + msg.substr(msg.length - 3) + "异常";
    }
    message.warning(msg)
    return Promise.reject(error)
  }
)

// 通用下载方法
export function download(url, params, filename, config) {
  // downloadLoadingInstance = ElLoading.service({ text: "正在下载数据，请稍候", background: "rgba(0, 0, 0, 0.7)", })
  return service.post(url, params, {
    transformRequest: [(params) => { return tansParams(params) }],
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    responseType: 'blob',
    ...config
  }).then(async (data) => {
    const isBlob = blobValidate(data);
    if (isBlob) {
      const blob = new Blob([data])
      // saveAs(blob, filename)
    } else {
      const resText = await data.text();
      const rspObj = JSON.parse(resText);
      const errMsg = errorCode[rspObj.code] || rspObj.msg || errorCode['default']
      message.error(errMsg)
    }
    // downloadLoadingInstance.close();
  }).catch((r) => {
    console.error(r)
    message.warning('下载文件出现错误，请联系管理员！')
    // downloadLoadingInstance.close();
  })
}

export default service
